// #region Imports

import { ThemeFactory } from './ThemeFactory';
import { SCHEME_DARK_BACKGROUND, SCHEME_DARK_DISABLED, SCHEME_DARK_FOREGROUND, SCHEME_DARK_HIGHLIGHT, SCHEME_DARK_LOWLIGHT, SCHEME_DARK_MIDDLELIGHT, SCHEME_DARK_SEMI_TRANSPARENT, SCHEME_DARK_TRANSPARENT, SCHEME_LIGHT_BACKGROUND, SCHEME_LIGHT_DISABLED, SCHEME_LIGHT_FOREGROUND, SCHEME_LIGHT_HIGHLIGHT, SCHEME_LIGHT_LOWLIGHT, SCHEME_LIGHT_MIDDLELIGHT, SCHEME_LIGHT_SEMI_TRANSPARENT, SCHEME_LIGHT_TRANSPARENT, TYPOGRAPHY_BODY1_TEXT_DECORATION, TYPOGRAPHY_BODY1_TEXT_TRANSFORM, TYPOGRAPHY_BODY2_FONT_SIZE, TYPOGRAPHY_BODY2_FONT_WEIGHT, TYPOGRAPHY_BODY2_LETTER_SPACING, TYPOGRAPHY_BODY2_LINE_HEIGHT, TYPOGRAPHY_BODY2_TEXT_DECORATION, TYPOGRAPHY_BODY2_TEXT_TRANSFORM, TYPOGRAPHY_BUTTON_FONT_SIZE, TYPOGRAPHY_BUTTON_FONT_WEIGHT, TYPOGRAPHY_BUTTON_LETTER_SPACING, TYPOGRAPHY_BUTTON_LINE_HEIGHT, TYPOGRAPHY_BUTTON_TEXT_DECORATION, TYPOGRAPHY_BUTTON_TEXT_TRANSFORM, TYPOGRAPHY_CAPTION_FONT_SIZE, TYPOGRAPHY_CAPTION_FONT_WEIGHT, TYPOGRAPHY_CAPTION_LETTER_SPACING, TYPOGRAPHY_CAPTION_LINE_HEIGHT, TYPOGRAPHY_CAPTION_TEXT_DECORATION, TYPOGRAPHY_CAPTION_TEXT_TRANSFORM, TYPOGRAPHY_HEADLINE2_FONT_SIZE, TYPOGRAPHY_HEADLINE2_FONT_WEIGHT, TYPOGRAPHY_HEADLINE2_LETTER_SPACING, TYPOGRAPHY_HEADLINE2_LINE_HEIGHT, TYPOGRAPHY_HEADLINE2_TEXT_DECORATION, TYPOGRAPHY_HEADLINE2_TEXT_TRANSFORM, TYPOGRAPHY_HEADLINE3_FONT_SIZE, TYPOGRAPHY_HEADLINE3_FONT_WEIGHT, TYPOGRAPHY_HEADLINE3_LETTER_SPACING, TYPOGRAPHY_HEADLINE3_LINE_HEIGHT, TYPOGRAPHY_HEADLINE3_TEXT_DECORATION, TYPOGRAPHY_HEADLINE3_TEXT_TRANSFORM, TYPOGRAPHY_HEADLINE4_FONT_SIZE, TYPOGRAPHY_HEADLINE4_FONT_WEIGHT, TYPOGRAPHY_HEADLINE4_LETTER_SPACING, TYPOGRAPHY_HEADLINE4_LINE_HEIGHT, TYPOGRAPHY_HEADLINE4_TEXT_DECORATION, TYPOGRAPHY_HEADLINE4_TEXT_TRANSFORM, TYPOGRAPHY_HEADLINE5_FONT_SIZE, TYPOGRAPHY_HEADLINE1_FONT_SIZE, TYPOGRAPHY_HEADLINE1_FONT_WEIGHT, TYPOGRAPHY_HEADLINE1_LETTER_SPACING, TYPOGRAPHY_HEADLINE1_LINE_HEIGHT, TYPOGRAPHY_HEADLINE1_TEXT_DECORATION, TYPOGRAPHY_HEADLINE1_TEXT_TRANSFORM, TYPOGRAPHY_HEADLINE5_FONT_WEIGHT, TYPOGRAPHY_HEADLINE5_LETTER_SPACING, TYPOGRAPHY_HEADLINE5_LINE_HEIGHT, TYPOGRAPHY_HEADLINE5_TEXT_DECORATION, TYPOGRAPHY_HEADLINE5_TEXT_TRANSFORM, TYPOGRAPHY_HEADLINE6_FONT_SIZE, TYPOGRAPHY_HEADLINE6_FONT_WEIGHT, TYPOGRAPHY_HEADLINE6_LETTER_SPACING, TYPOGRAPHY_HEADLINE6_LINE_HEIGHT, TYPOGRAPHY_HEADLINE6_TEXT_DECORATION, TYPOGRAPHY_HEADLINE6_TEXT_TRANSFORM, TYPOGRAPHY_OVERLINE_FONT_SIZE, TYPOGRAPHY_OVERLINE_FONT_WEIGHT, TYPOGRAPHY_OVERLINE_LETTER_SPACING, TYPOGRAPHY_OVERLINE_LINE_HEIGHT, TYPOGRAPHY_OVERLINE_TEXT_DECORATION, TYPOGRAPHY_OVERLINE_TEXT_TRANSFORM, TYPOGRAPHY_SUBTITLE1_FONT_SIZE, TYPOGRAPHY_SUBTITLE1_FONT_WEIGHT, TYPOGRAPHY_SUBTITLE1_LETTER_SPACING, TYPOGRAPHY_SUBTITLE1_LINE_HEIGHT, TYPOGRAPHY_SUBTITLE1_TEXT_DECORATION, TYPOGRAPHY_SUBTITLE1_TEXT_TRANSFORM, TYPOGRAPHY_SUBTITLE2_FONT_SIZE, TYPOGRAPHY_SUBTITLE2_FONT_WEIGHT, TYPOGRAPHY_SUBTITLE2_LETTER_SPACING, TYPOGRAPHY_SUBTITLE2_LINE_HEIGHT, TYPOGRAPHY_SUBTITLE2_TEXT_DECORATION, TYPOGRAPHY_SUBTITLE2_TEXT_TRANSFORM, LAYOUT_RADIUS, LAYOUT_SPACE, LAYOUT_THICKNESS, TYPOGRAPHY_BODY1_FONT_SIZE, TYPOGRAPHY_BODY1_LINE_HEIGHT, ELEVATION_DARK_BOLD, ELEVATION_DARK_EXTRABOLD, ELEVATION_DARK_LIGHT, ELEVATION_DARK_REGULAR, ELEVATION_DARK_SEMIBOLD, ELEVATION_DARK_SEMILIGHT, ELEVATION_LIGHT_BOLD, ELEVATION_LIGHT_EXTRABOLD, ELEVATION_LIGHT_LIGHT, ELEVATION_LIGHT_REGULAR, ELEVATION_LIGHT_SEMIBOLD, ELEVATION_LIGHT_SEMILIGHT, TYPOGRAPHY_BODY1_FONT_WEIGHT, TYPOGRAPHY_BODY1_LETTER_SPACING, FONT_FAMILY, NAME, COLOR_LIGHT_PRIMARY_0, COLOR_DARK_PRIMARY_0, COLOR_DARK_PRIMARY_100, COLOR_DARK_PRIMARY_200, COLOR_DARK_PRIMARY_300, COLOR_DARK_PRIMARY_400, COLOR_DARK_PRIMARY_50, COLOR_DARK_PRIMARY_500, COLOR_DARK_PRIMARY_600, COLOR_DARK_PRIMARY_700, COLOR_DARK_PRIMARY_800, COLOR_DARK_PRIMARY_900, COLOR_DARK_SECONDARY_0, COLOR_DARK_SECONDARY_100, COLOR_DARK_SECONDARY_200, COLOR_DARK_SECONDARY_300, COLOR_DARK_SECONDARY_400, COLOR_DARK_SECONDARY_50, COLOR_DARK_SECONDARY_500, COLOR_DARK_SECONDARY_600, COLOR_DARK_SECONDARY_700, COLOR_DARK_SECONDARY_800, COLOR_DARK_SECONDARY_900, COLOR_LIGHT_PRIMARY_100, COLOR_LIGHT_PRIMARY_200, COLOR_LIGHT_PRIMARY_300, COLOR_LIGHT_PRIMARY_400, COLOR_LIGHT_PRIMARY_50, COLOR_LIGHT_PRIMARY_500, COLOR_LIGHT_PRIMARY_600, COLOR_LIGHT_PRIMARY_700, COLOR_LIGHT_PRIMARY_800, COLOR_LIGHT_PRIMARY_900, COLOR_LIGHT_SECONDARY_0, COLOR_LIGHT_SECONDARY_100, COLOR_LIGHT_SECONDARY_200, COLOR_LIGHT_SECONDARY_300, COLOR_LIGHT_SECONDARY_400, COLOR_LIGHT_SECONDARY_50, COLOR_LIGHT_SECONDARY_500, COLOR_LIGHT_SECONDARY_600, COLOR_LIGHT_SECONDARY_700, COLOR_LIGHT_SECONDARY_800, COLOR_LIGHT_SECONDARY_900, TYPOGRAPHY_HEADLINE1_FONT_FAMILY, TYPOGRAPHY_HEADLINE2_FONT_FAMILY, TYPOGRAPHY_HEADLINE3_FONT_FAMILY, TYPOGRAPHY_SUBTITLE1_FONT_FAMILY, TYPOGRAPHY_HEADLINE4_FONT_FAMILY, TYPOGRAPHY_HEADLINE5_FONT_FAMILY, TYPOGRAPHY_HEADLINE6_FONT_FAMILY, TYPOGRAPHY_BODY1_FONT_FAMILY, TYPOGRAPHY_OVERLINE_FONT_FAMILY, TYPOGRAPHY_BODY2_FONT_FAMILY, TYPOGRAPHY_BUTTON_FONT_FAMILY, TYPOGRAPHY_CAPTION_FONT_FAMILY, TYPOGRAPHY_SUBTITLE2_FONT_FAMILY, SCHEME_LIGHT_CONTRAST, SCHEME_DARK_CONTRAST, COLOR_LIGHT_DANGER_0, COLOR_LIGHT_DANGER_100, COLOR_LIGHT_DANGER_200, COLOR_LIGHT_DANGER_300, COLOR_LIGHT_DANGER_400, COLOR_LIGHT_DANGER_50, COLOR_LIGHT_DANGER_500, COLOR_LIGHT_DANGER_600, COLOR_LIGHT_DANGER_700, COLOR_LIGHT_DANGER_800, COLOR_LIGHT_DANGER_900, COLOR_LIGHT_INFO_0, COLOR_LIGHT_INFO_100, COLOR_LIGHT_INFO_200, COLOR_LIGHT_INFO_300, COLOR_LIGHT_INFO_400, COLOR_LIGHT_INFO_50, COLOR_LIGHT_INFO_500, COLOR_LIGHT_INFO_600, COLOR_LIGHT_INFO_700, COLOR_LIGHT_INFO_800, COLOR_LIGHT_INFO_900, COLOR_LIGHT_WARNING_0, COLOR_LIGHT_WARNING_100, COLOR_LIGHT_WARNING_200, COLOR_LIGHT_WARNING_300, COLOR_LIGHT_WARNING_400, COLOR_LIGHT_WARNING_50, COLOR_LIGHT_WARNING_500, COLOR_LIGHT_WARNING_600, COLOR_LIGHT_WARNING_700, COLOR_LIGHT_WARNING_800, COLOR_LIGHT_WARNING_900, COLOR_LIGHT_NEUTRAL_0, COLOR_LIGHT_NEUTRAL_100, COLOR_LIGHT_NEUTRAL_200, COLOR_LIGHT_NEUTRAL_300, COLOR_LIGHT_NEUTRAL_400, COLOR_LIGHT_NEUTRAL_50, COLOR_LIGHT_NEUTRAL_500, COLOR_LIGHT_NEUTRAL_600, COLOR_LIGHT_NEUTRAL_700, COLOR_LIGHT_NEUTRAL_800, COLOR_LIGHT_NEUTRAL_900, COLOR_LIGHT_SUCCESS_0, COLOR_LIGHT_SUCCESS_100, COLOR_LIGHT_SUCCESS_200, COLOR_LIGHT_SUCCESS_300, COLOR_LIGHT_SUCCESS_400, COLOR_LIGHT_SUCCESS_50, COLOR_LIGHT_SUCCESS_500, COLOR_LIGHT_SUCCESS_600, COLOR_LIGHT_SUCCESS_700, COLOR_LIGHT_SUCCESS_800, COLOR_LIGHT_SUCCESS_900, COLOR_DARK_DANGER_0, COLOR_DARK_DANGER_100, COLOR_DARK_DANGER_200, COLOR_DARK_DANGER_300, COLOR_DARK_DANGER_400, COLOR_DARK_DANGER_50, COLOR_DARK_DANGER_500, COLOR_DARK_DANGER_600, COLOR_DARK_DANGER_700, COLOR_DARK_DANGER_800, COLOR_DARK_DANGER_900, COLOR_DARK_INFO_0, COLOR_DARK_INFO_100, COLOR_DARK_INFO_200, COLOR_DARK_INFO_300, COLOR_DARK_INFO_400, COLOR_DARK_INFO_50, COLOR_DARK_INFO_500, COLOR_DARK_INFO_600, COLOR_DARK_INFO_700, COLOR_DARK_INFO_800, COLOR_DARK_INFO_900, COLOR_DARK_NEUTRAL_0, COLOR_DARK_NEUTRAL_100, COLOR_DARK_NEUTRAL_200, COLOR_DARK_NEUTRAL_300, COLOR_DARK_NEUTRAL_400, COLOR_DARK_NEUTRAL_50, COLOR_DARK_NEUTRAL_500, COLOR_DARK_NEUTRAL_600, COLOR_DARK_NEUTRAL_700, COLOR_DARK_NEUTRAL_800, COLOR_DARK_NEUTRAL_900, COLOR_DARK_SUCCESS_0, COLOR_DARK_SUCCESS_100, COLOR_DARK_SUCCESS_200, COLOR_DARK_SUCCESS_300, COLOR_DARK_SUCCESS_400, COLOR_DARK_SUCCESS_50, COLOR_DARK_SUCCESS_500, COLOR_DARK_SUCCESS_600, COLOR_DARK_SUCCESS_700, COLOR_DARK_SUCCESS_800, COLOR_DARK_SUCCESS_900, COLOR_DARK_WARNING_0, COLOR_DARK_WARNING_100, COLOR_DARK_WARNING_200, COLOR_DARK_WARNING_300, COLOR_DARK_WARNING_400, COLOR_DARK_WARNING_50, COLOR_DARK_WARNING_500, COLOR_DARK_WARNING_600, COLOR_DARK_WARNING_700, COLOR_DARK_WARNING_800, COLOR_DARK_WARNING_900, VARIANT_PRIMARY, VARIANT_SECONDARY, ELEVATION_KEY_BOLD, ELEVATION_KEY_EXTRABOLD, ELEVATION_KEY_LIGHT, ELEVATION_KEY_REGULAR, ELEVATION_KEY_SEMIBOLD, ELEVATION_KEY_SEMILIGHT, VARIANT_DANGER, VARIANT_INFO, VARIANT_NEUTRAL, VARIANT_SUCCESS, VARIANT_WARNING, TYPOGRAPHY_KEY_BODY1, TYPOGRAPHY_KEY_BODY2, TYPOGRAPHY_KEY_BUTTON, TYPOGRAPHY_KEY_CAPTION, TYPOGRAPHY_KEY_HEADLINE1, TYPOGRAPHY_KEY_HEADLINE2, TYPOGRAPHY_KEY_HEADLINE3, TYPOGRAPHY_KEY_HEADLINE4, TYPOGRAPHY_KEY_HEADLINE5, TYPOGRAPHY_KEY_HEADLINE6, TYPOGRAPHY_KEY_OVERLINE, TYPOGRAPHY_KEY_SUBTITLE1, TYPOGRAPHY_KEY_SUBTITLE2, SCHEME_DARK_SURFACE, SCHEME_DARK_SELECTION, SCHEME_LIGHT_SELECTION, SCHEME_LIGHT_SURFACE, COLOR_DARK_HIGHLIGHT_600, COLOR_DARK_HIGHLIGHT_100, COLOR_DARK_HIGHLIGHT_0, COLOR_DARK_HIGHLIGHT_200, COLOR_DARK_HIGHLIGHT_300, COLOR_DARK_HIGHLIGHT_400, COLOR_DARK_HIGHLIGHT_50, COLOR_DARK_HIGHLIGHT_500, COLOR_DARK_HIGHLIGHT_700, COLOR_DARK_HIGHLIGHT_800, COLOR_DARK_HIGHLIGHT_900, COLOR_DARK_TERTIARY_0, COLOR_DARK_TERTIARY_100, COLOR_DARK_TERTIARY_200, COLOR_DARK_TERTIARY_300, COLOR_DARK_TERTIARY_400, COLOR_DARK_TERTIARY_50, COLOR_DARK_TERTIARY_500, COLOR_DARK_TERTIARY_600, COLOR_DARK_TERTIARY_700, COLOR_DARK_TERTIARY_800, COLOR_DARK_TERTIARY_900, COLOR_LIGHT_HIGHLIGHT_0, COLOR_LIGHT_HIGHLIGHT_100, COLOR_LIGHT_HIGHLIGHT_200, COLOR_LIGHT_HIGHLIGHT_300, COLOR_LIGHT_HIGHLIGHT_400, COLOR_LIGHT_HIGHLIGHT_50, COLOR_LIGHT_HIGHLIGHT_500, COLOR_LIGHT_HIGHLIGHT_600, COLOR_LIGHT_HIGHLIGHT_700, COLOR_LIGHT_HIGHLIGHT_800, COLOR_LIGHT_HIGHLIGHT_900, COLOR_LIGHT_TERTIARY_0, COLOR_LIGHT_TERTIARY_100, COLOR_LIGHT_TERTIARY_200, COLOR_LIGHT_TERTIARY_300, COLOR_LIGHT_TERTIARY_400, COLOR_LIGHT_TERTIARY_50, COLOR_LIGHT_TERTIARY_500, COLOR_LIGHT_TERTIARY_600, COLOR_LIGHT_TERTIARY_700, COLOR_LIGHT_TERTIARY_800, COLOR_LIGHT_TERTIARY_900 } from './Tokens/MemphisTokens';
import type { IThemeMetadata } from './Utils/IThemeMetadata';

// #endregion

export namespace MemphisTheme {

    export const MEMPHIS_THEME = ThemeFactory.create({
        name: NAME,
        scheme: {
            light: {
                surface: SCHEME_LIGHT_SURFACE,
                background: SCHEME_LIGHT_BACKGROUND,
                foreground: SCHEME_LIGHT_FOREGROUND,
                highlight: SCHEME_LIGHT_HIGHLIGHT,
                middlelight: SCHEME_LIGHT_MIDDLELIGHT,
                lowlight: SCHEME_LIGHT_LOWLIGHT,
                transparent: SCHEME_LIGHT_TRANSPARENT,
                semiTransparent: SCHEME_LIGHT_SEMI_TRANSPARENT,
                disabled: SCHEME_LIGHT_DISABLED,
                contrast: SCHEME_LIGHT_CONTRAST,
                selection: SCHEME_LIGHT_SELECTION
            },
            dark: {
                surface: SCHEME_DARK_SURFACE,
                background: SCHEME_DARK_BACKGROUND,
                foreground: SCHEME_DARK_FOREGROUND,
                highlight: SCHEME_DARK_HIGHLIGHT,
                middlelight: SCHEME_DARK_MIDDLELIGHT,
                lowlight: SCHEME_DARK_LOWLIGHT,
                transparent: SCHEME_DARK_TRANSPARENT,
                semiTransparent: SCHEME_DARK_SEMI_TRANSPARENT,
                disabled: SCHEME_DARK_DISABLED,
                contrast: SCHEME_DARK_CONTRAST,
                selection: SCHEME_DARK_SELECTION
            }
        },
        palette: {
            light: {
                primary: {
                    0: COLOR_LIGHT_PRIMARY_0,
                    50: COLOR_LIGHT_PRIMARY_50,
                    100: COLOR_LIGHT_PRIMARY_100,
                    200: COLOR_LIGHT_PRIMARY_200,
                    300: COLOR_LIGHT_PRIMARY_300,
                    400: COLOR_LIGHT_PRIMARY_400,
                    500: COLOR_LIGHT_PRIMARY_500,
                    600: COLOR_LIGHT_PRIMARY_600,
                    700: COLOR_LIGHT_PRIMARY_700,
                    800: COLOR_LIGHT_PRIMARY_800,
                    900: COLOR_LIGHT_PRIMARY_900
                },
                secondary: {
                    0: COLOR_LIGHT_SECONDARY_0,
                    50: COLOR_LIGHT_SECONDARY_50,
                    100: COLOR_LIGHT_SECONDARY_100,
                    200: COLOR_LIGHT_SECONDARY_200,
                    300: COLOR_LIGHT_SECONDARY_300,
                    400: COLOR_LIGHT_SECONDARY_400,
                    500: COLOR_LIGHT_SECONDARY_500,
                    600: COLOR_LIGHT_SECONDARY_600,
                    700: COLOR_LIGHT_SECONDARY_700,
                    800: COLOR_LIGHT_SECONDARY_800,
                    900: COLOR_LIGHT_SECONDARY_900
                },
                tertiary: {
                    0: COLOR_LIGHT_TERTIARY_0,
                    50: COLOR_LIGHT_TERTIARY_50,
                    100: COLOR_LIGHT_TERTIARY_100,
                    200: COLOR_LIGHT_TERTIARY_200,
                    300: COLOR_LIGHT_TERTIARY_300,
                    400: COLOR_LIGHT_TERTIARY_400,
                    500: COLOR_LIGHT_TERTIARY_500,
                    600: COLOR_LIGHT_TERTIARY_600,
                    700: COLOR_LIGHT_TERTIARY_700,
                    800: COLOR_LIGHT_TERTIARY_800,
                    900: COLOR_LIGHT_TERTIARY_900
                },
                info: {
                    0: COLOR_LIGHT_INFO_0,
                    50: COLOR_LIGHT_INFO_50,
                    100: COLOR_LIGHT_INFO_100,
                    200: COLOR_LIGHT_INFO_200,
                    300: COLOR_LIGHT_INFO_300,
                    400: COLOR_LIGHT_INFO_400,
                    500: COLOR_LIGHT_INFO_500,
                    600: COLOR_LIGHT_INFO_600,
                    700: COLOR_LIGHT_INFO_700,
                    800: COLOR_LIGHT_INFO_800,
                    900: COLOR_LIGHT_INFO_900
                },
                warning: {
                    0: COLOR_LIGHT_WARNING_0,
                    50: COLOR_LIGHT_WARNING_50,
                    100: COLOR_LIGHT_WARNING_100,
                    200: COLOR_LIGHT_WARNING_200,
                    300: COLOR_LIGHT_WARNING_300,
                    400: COLOR_LIGHT_WARNING_400,
                    500: COLOR_LIGHT_WARNING_500,
                    600: COLOR_LIGHT_WARNING_600,
                    700: COLOR_LIGHT_WARNING_700,
                    800: COLOR_LIGHT_WARNING_800,
                    900: COLOR_LIGHT_WARNING_900
                },
                danger: {
                    0: COLOR_LIGHT_DANGER_0,
                    50: COLOR_LIGHT_DANGER_50,
                    100: COLOR_LIGHT_DANGER_100,
                    200: COLOR_LIGHT_DANGER_200,
                    300: COLOR_LIGHT_DANGER_300,
                    400: COLOR_LIGHT_DANGER_400,
                    500: COLOR_LIGHT_DANGER_500,
                    600: COLOR_LIGHT_DANGER_600,
                    700: COLOR_LIGHT_DANGER_700,
                    800: COLOR_LIGHT_DANGER_800,
                    900: COLOR_LIGHT_DANGER_900
                },
                success: {
                    0: COLOR_LIGHT_SUCCESS_0,
                    50: COLOR_LIGHT_SUCCESS_50,
                    100: COLOR_LIGHT_SUCCESS_100,
                    200: COLOR_LIGHT_SUCCESS_200,
                    300: COLOR_LIGHT_SUCCESS_300,
                    400: COLOR_LIGHT_SUCCESS_400,
                    500: COLOR_LIGHT_SUCCESS_500,
                    600: COLOR_LIGHT_SUCCESS_600,
                    700: COLOR_LIGHT_SUCCESS_700,
                    800: COLOR_LIGHT_SUCCESS_800,
                    900: COLOR_LIGHT_SUCCESS_900
                },
                highlight: {
                    0: COLOR_LIGHT_HIGHLIGHT_0,
                    50: COLOR_LIGHT_HIGHLIGHT_50,
                    100: COLOR_LIGHT_HIGHLIGHT_100,
                    200: COLOR_LIGHT_HIGHLIGHT_200,
                    300: COLOR_LIGHT_HIGHLIGHT_300,
                    400: COLOR_LIGHT_HIGHLIGHT_400,
                    500: COLOR_LIGHT_HIGHLIGHT_500,
                    600: COLOR_LIGHT_HIGHLIGHT_600,
                    700: COLOR_LIGHT_HIGHLIGHT_700,
                    800: COLOR_LIGHT_HIGHLIGHT_800,
                    900: COLOR_LIGHT_HIGHLIGHT_900
                },
                neutral: {
                    0: COLOR_LIGHT_NEUTRAL_0,
                    50: COLOR_LIGHT_NEUTRAL_50,
                    100: COLOR_LIGHT_NEUTRAL_100,
                    200: COLOR_LIGHT_NEUTRAL_200,
                    300: COLOR_LIGHT_NEUTRAL_300,
                    400: COLOR_LIGHT_NEUTRAL_400,
                    500: COLOR_LIGHT_NEUTRAL_500,
                    600: COLOR_LIGHT_NEUTRAL_600,
                    700: COLOR_LIGHT_NEUTRAL_700,
                    800: COLOR_LIGHT_NEUTRAL_800,
                    900: COLOR_LIGHT_NEUTRAL_900
                }
            },
            dark: {
                primary: {
                    0: COLOR_DARK_PRIMARY_0,
                    50: COLOR_DARK_PRIMARY_50,
                    100: COLOR_DARK_PRIMARY_100,
                    200: COLOR_DARK_PRIMARY_200,
                    300: COLOR_DARK_PRIMARY_300,
                    400: COLOR_DARK_PRIMARY_400,
                    500: COLOR_DARK_PRIMARY_500,
                    600: COLOR_DARK_PRIMARY_600,
                    700: COLOR_DARK_PRIMARY_700,
                    800: COLOR_DARK_PRIMARY_800,
                    900: COLOR_DARK_PRIMARY_900
                },
                secondary: {
                    0: COLOR_DARK_SECONDARY_0,
                    50: COLOR_DARK_SECONDARY_50,
                    100: COLOR_DARK_SECONDARY_100,
                    200: COLOR_DARK_SECONDARY_200,
                    300: COLOR_DARK_SECONDARY_300,
                    400: COLOR_DARK_SECONDARY_400,
                    500: COLOR_DARK_SECONDARY_500,
                    600: COLOR_DARK_SECONDARY_600,
                    700: COLOR_DARK_SECONDARY_700,
                    800: COLOR_DARK_SECONDARY_800,
                    900: COLOR_DARK_SECONDARY_900
                },
                tertiary: {
                    0: COLOR_DARK_TERTIARY_0,
                    50: COLOR_DARK_TERTIARY_50,
                    100: COLOR_DARK_TERTIARY_100,
                    200: COLOR_DARK_TERTIARY_200,
                    300: COLOR_DARK_TERTIARY_300,
                    400: COLOR_DARK_TERTIARY_400,
                    500: COLOR_DARK_TERTIARY_500,
                    600: COLOR_DARK_TERTIARY_600,
                    700: COLOR_DARK_TERTIARY_700,
                    800: COLOR_DARK_TERTIARY_800,
                    900: COLOR_DARK_TERTIARY_900
                },
                info: {
                    0: COLOR_DARK_INFO_0,
                    50: COLOR_DARK_INFO_50,
                    100: COLOR_DARK_INFO_100,
                    200: COLOR_DARK_INFO_200,
                    300: COLOR_DARK_INFO_300,
                    400: COLOR_DARK_INFO_400,
                    500: COLOR_DARK_INFO_500,
                    600: COLOR_DARK_INFO_600,
                    700: COLOR_DARK_INFO_700,
                    800: COLOR_DARK_INFO_800,
                    900: COLOR_DARK_INFO_900
                },
                warning: {
                    0: COLOR_DARK_WARNING_0,
                    50: COLOR_DARK_WARNING_50,
                    100: COLOR_DARK_WARNING_100,
                    200: COLOR_DARK_WARNING_200,
                    300: COLOR_DARK_WARNING_300,
                    400: COLOR_DARK_WARNING_400,
                    500: COLOR_DARK_WARNING_500,
                    600: COLOR_DARK_WARNING_600,
                    700: COLOR_DARK_WARNING_700,
                    800: COLOR_DARK_WARNING_800,
                    900: COLOR_DARK_WARNING_900
                },
                danger: {
                    0: COLOR_DARK_DANGER_0,
                    50: COLOR_DARK_DANGER_50,
                    100: COLOR_DARK_DANGER_100,
                    200: COLOR_DARK_DANGER_200,
                    300: COLOR_DARK_DANGER_300,
                    400: COLOR_DARK_DANGER_400,
                    500: COLOR_DARK_DANGER_500,
                    600: COLOR_DARK_DANGER_600,
                    700: COLOR_DARK_DANGER_700,
                    800: COLOR_DARK_DANGER_800,
                    900: COLOR_DARK_DANGER_900
                },
                success: {
                    0: COLOR_DARK_SUCCESS_0,
                    50: COLOR_DARK_SUCCESS_50,
                    100: COLOR_DARK_SUCCESS_100,
                    200: COLOR_DARK_SUCCESS_200,
                    300: COLOR_DARK_SUCCESS_300,
                    400: COLOR_DARK_SUCCESS_400,
                    500: COLOR_DARK_SUCCESS_500,
                    600: COLOR_DARK_SUCCESS_600,
                    700: COLOR_DARK_SUCCESS_700,
                    800: COLOR_DARK_SUCCESS_800,
                    900: COLOR_DARK_SUCCESS_900
                },
                highlight: {
                    0: COLOR_DARK_HIGHLIGHT_0,
                    50: COLOR_DARK_HIGHLIGHT_50,
                    100: COLOR_DARK_HIGHLIGHT_100,
                    200: COLOR_DARK_HIGHLIGHT_200,
                    300: COLOR_DARK_HIGHLIGHT_300,
                    400: COLOR_DARK_HIGHLIGHT_400,
                    500: COLOR_DARK_HIGHLIGHT_500,
                    600: COLOR_DARK_HIGHLIGHT_600,
                    700: COLOR_DARK_HIGHLIGHT_700,
                    800: COLOR_DARK_HIGHLIGHT_800,
                    900: COLOR_DARK_HIGHLIGHT_900
                },
                neutral: {
                    0: COLOR_DARK_NEUTRAL_0,
                    50: COLOR_DARK_NEUTRAL_50,
                    100: COLOR_DARK_NEUTRAL_100,
                    200: COLOR_DARK_NEUTRAL_200,
                    300: COLOR_DARK_NEUTRAL_300,
                    400: COLOR_DARK_NEUTRAL_400,
                    500: COLOR_DARK_NEUTRAL_500,
                    600: COLOR_DARK_NEUTRAL_600,
                    700: COLOR_DARK_NEUTRAL_700,
                    800: COLOR_DARK_NEUTRAL_800,
                    900: COLOR_DARK_NEUTRAL_900
                }
            }
        },
        fontFamily: FONT_FAMILY,
        typography: {
            headline1: {
                fontFamily: TYPOGRAPHY_HEADLINE1_FONT_FAMILY,
                fontSize: TYPOGRAPHY_HEADLINE1_FONT_SIZE,
                lineHeight: TYPOGRAPHY_HEADLINE1_LINE_HEIGHT,
                fontWeight: TYPOGRAPHY_HEADLINE1_FONT_WEIGHT,
                letterSpacing: TYPOGRAPHY_HEADLINE1_LETTER_SPACING,
                textDecoration: TYPOGRAPHY_HEADLINE1_TEXT_DECORATION,
                textTransform: TYPOGRAPHY_HEADLINE1_TEXT_TRANSFORM
            },
            headline2: {
                fontFamily: TYPOGRAPHY_HEADLINE2_FONT_FAMILY,
                fontSize: TYPOGRAPHY_HEADLINE2_FONT_SIZE,
                lineHeight: TYPOGRAPHY_HEADLINE2_LINE_HEIGHT,
                fontWeight: TYPOGRAPHY_HEADLINE2_FONT_WEIGHT,
                letterSpacing: TYPOGRAPHY_HEADLINE2_LETTER_SPACING,
                textDecoration: TYPOGRAPHY_HEADLINE2_TEXT_DECORATION,
                textTransform: TYPOGRAPHY_HEADLINE2_TEXT_TRANSFORM
            },
            headline3: {
                fontFamily: TYPOGRAPHY_HEADLINE3_FONT_FAMILY,
                fontSize: TYPOGRAPHY_HEADLINE3_FONT_SIZE,
                lineHeight: TYPOGRAPHY_HEADLINE3_LINE_HEIGHT,
                fontWeight: TYPOGRAPHY_HEADLINE3_FONT_WEIGHT,
                letterSpacing: TYPOGRAPHY_HEADLINE3_LETTER_SPACING,
                textDecoration: TYPOGRAPHY_HEADLINE3_TEXT_DECORATION,
                textTransform: TYPOGRAPHY_HEADLINE3_TEXT_TRANSFORM
            },
            headline4: {
                fontFamily: TYPOGRAPHY_HEADLINE4_FONT_FAMILY,
                fontSize: TYPOGRAPHY_HEADLINE4_FONT_SIZE,
                lineHeight: TYPOGRAPHY_HEADLINE4_LINE_HEIGHT,
                fontWeight: TYPOGRAPHY_HEADLINE4_FONT_WEIGHT,
                letterSpacing: TYPOGRAPHY_HEADLINE4_LETTER_SPACING,
                textDecoration: TYPOGRAPHY_HEADLINE4_TEXT_DECORATION,
                textTransform: TYPOGRAPHY_HEADLINE4_TEXT_TRANSFORM
            },
            headline5: {
                fontFamily: TYPOGRAPHY_HEADLINE5_FONT_FAMILY,
                fontSize: TYPOGRAPHY_HEADLINE5_FONT_SIZE,
                lineHeight: TYPOGRAPHY_HEADLINE5_LINE_HEIGHT,
                fontWeight: TYPOGRAPHY_HEADLINE5_FONT_WEIGHT,
                letterSpacing: TYPOGRAPHY_HEADLINE5_LETTER_SPACING,
                textDecoration: TYPOGRAPHY_HEADLINE5_TEXT_DECORATION,
                textTransform: TYPOGRAPHY_HEADLINE5_TEXT_TRANSFORM
            },
            headline6: {
                fontFamily: TYPOGRAPHY_HEADLINE6_FONT_FAMILY,
                fontSize: TYPOGRAPHY_HEADLINE6_FONT_SIZE,
                lineHeight: TYPOGRAPHY_HEADLINE6_LINE_HEIGHT,
                fontWeight: TYPOGRAPHY_HEADLINE6_FONT_WEIGHT,
                letterSpacing: TYPOGRAPHY_HEADLINE6_LETTER_SPACING,
                textDecoration: TYPOGRAPHY_HEADLINE6_TEXT_DECORATION,
                textTransform: TYPOGRAPHY_HEADLINE6_TEXT_TRANSFORM
            },
            subtitle1: {
                fontFamily: TYPOGRAPHY_SUBTITLE1_FONT_FAMILY,
                fontSize: TYPOGRAPHY_SUBTITLE1_FONT_SIZE,
                lineHeight: TYPOGRAPHY_SUBTITLE1_LINE_HEIGHT,
                fontWeight: TYPOGRAPHY_SUBTITLE1_FONT_WEIGHT,
                letterSpacing: TYPOGRAPHY_SUBTITLE1_LETTER_SPACING,
                textDecoration: TYPOGRAPHY_SUBTITLE1_TEXT_DECORATION,
                textTransform: TYPOGRAPHY_SUBTITLE1_TEXT_TRANSFORM
            },
            subtitle2: {
                fontFamily: TYPOGRAPHY_SUBTITLE2_FONT_FAMILY,
                fontSize: TYPOGRAPHY_SUBTITLE2_FONT_SIZE,
                lineHeight: TYPOGRAPHY_SUBTITLE2_LINE_HEIGHT,
                fontWeight: TYPOGRAPHY_SUBTITLE2_FONT_WEIGHT,
                letterSpacing: TYPOGRAPHY_SUBTITLE2_LETTER_SPACING,
                textDecoration: TYPOGRAPHY_SUBTITLE2_TEXT_DECORATION,
                textTransform: TYPOGRAPHY_SUBTITLE2_TEXT_TRANSFORM
            },
            body1: {
                fontFamily: TYPOGRAPHY_BODY1_FONT_FAMILY,
                fontSize: TYPOGRAPHY_BODY1_FONT_SIZE,
                lineHeight: TYPOGRAPHY_BODY1_LINE_HEIGHT,
                fontWeight: TYPOGRAPHY_BODY1_FONT_WEIGHT,
                letterSpacing: TYPOGRAPHY_BODY1_LETTER_SPACING,
                textDecoration: TYPOGRAPHY_BODY1_TEXT_DECORATION,
                textTransform: TYPOGRAPHY_BODY1_TEXT_TRANSFORM
            },
            body2: {
                fontFamily: TYPOGRAPHY_BODY2_FONT_FAMILY,
                fontSize: TYPOGRAPHY_BODY2_FONT_SIZE,
                lineHeight: TYPOGRAPHY_BODY2_LINE_HEIGHT,
                fontWeight: TYPOGRAPHY_BODY2_FONT_WEIGHT,
                letterSpacing: TYPOGRAPHY_BODY2_LETTER_SPACING,
                textDecoration: TYPOGRAPHY_BODY2_TEXT_DECORATION,
                textTransform: TYPOGRAPHY_BODY2_TEXT_TRANSFORM
            },
            caption: {
                fontFamily: TYPOGRAPHY_CAPTION_FONT_FAMILY,
                fontSize: TYPOGRAPHY_CAPTION_FONT_SIZE,
                lineHeight: TYPOGRAPHY_CAPTION_LINE_HEIGHT,
                fontWeight: TYPOGRAPHY_CAPTION_FONT_WEIGHT,
                letterSpacing: TYPOGRAPHY_CAPTION_LETTER_SPACING,
                textDecoration: TYPOGRAPHY_CAPTION_TEXT_DECORATION,
                textTransform: TYPOGRAPHY_CAPTION_TEXT_TRANSFORM
            },
            overline: {
                fontFamily: TYPOGRAPHY_OVERLINE_FONT_FAMILY,
                fontSize: TYPOGRAPHY_OVERLINE_FONT_SIZE,
                lineHeight: TYPOGRAPHY_OVERLINE_LINE_HEIGHT,
                fontWeight: TYPOGRAPHY_OVERLINE_FONT_WEIGHT,
                letterSpacing: TYPOGRAPHY_OVERLINE_LETTER_SPACING,
                textDecoration: TYPOGRAPHY_OVERLINE_TEXT_DECORATION,
                textTransform: TYPOGRAPHY_OVERLINE_TEXT_TRANSFORM
            },
            button: {
                fontFamily: TYPOGRAPHY_BUTTON_FONT_FAMILY,
                fontSize: TYPOGRAPHY_BUTTON_FONT_SIZE,
                lineHeight: TYPOGRAPHY_BUTTON_LINE_HEIGHT,
                fontWeight: TYPOGRAPHY_BUTTON_FONT_WEIGHT,
                letterSpacing: TYPOGRAPHY_BUTTON_LETTER_SPACING,
                textDecoration: TYPOGRAPHY_BUTTON_TEXT_DECORATION,
                textTransform: TYPOGRAPHY_BUTTON_TEXT_TRANSFORM
            }
        },
        layout: {
            radius: LAYOUT_RADIUS,
            space: LAYOUT_SPACE,
            thickness: LAYOUT_THICKNESS
        },
        elevation: {
            light: {
                light: ELEVATION_LIGHT_LIGHT,
                semilight: ELEVATION_LIGHT_SEMILIGHT,
                regular: ELEVATION_LIGHT_REGULAR,
                semibold: ELEVATION_LIGHT_SEMIBOLD,
                bold: ELEVATION_LIGHT_BOLD,
                extrabold: ELEVATION_LIGHT_EXTRABOLD
            },
            dark: {
                light: ELEVATION_DARK_LIGHT,
                semilight: ELEVATION_DARK_SEMILIGHT,
                regular: ELEVATION_DARK_REGULAR,
                semibold: ELEVATION_DARK_SEMIBOLD,
                bold: ELEVATION_DARK_BOLD,
                extrabold: ELEVATION_DARK_EXTRABOLD
            }
        }
    });

    export const MEMPHIS_THEME_PALETTES = [VARIANT_PRIMARY, VARIANT_SECONDARY, VARIANT_DANGER, VARIANT_INFO, VARIANT_NEUTRAL, VARIANT_SUCCESS, VARIANT_WARNING];

    export const MEMPHIS_THEME_PALETTE_VARIANTS = ['0', '50', '100', '200', '300', '400', '500', '600', '700', '800', '900'];

    export const MEMPHIS_THEME_SCHEMES = ['light', 'dark'];

    export const MEMPHIS_THEME_SCHEME_VARIANTS = ['surface', 'background', 'foreground', 'highlight', 'middlelight', 'lowlight', 'transparent', 'semiTransparent', 'disabled', 'contrast', 'selection'];

    export const MEMPHIS_THEME_ELEVATION = ['light', 'dark'];

    export const MEMPHIS_THEME_ELEVATION_VARIANTS = [ELEVATION_KEY_LIGHT, ELEVATION_KEY_SEMILIGHT, ELEVATION_KEY_REGULAR, ELEVATION_KEY_SEMIBOLD, ELEVATION_KEY_BOLD, ELEVATION_KEY_EXTRABOLD];

    export const MEMPHIS_THEME_TYPOGRAPHY = [TYPOGRAPHY_KEY_HEADLINE1, TYPOGRAPHY_KEY_HEADLINE2, TYPOGRAPHY_KEY_HEADLINE3, TYPOGRAPHY_KEY_HEADLINE4, TYPOGRAPHY_KEY_HEADLINE5, TYPOGRAPHY_KEY_HEADLINE6, TYPOGRAPHY_KEY_SUBTITLE1, TYPOGRAPHY_KEY_SUBTITLE2, TYPOGRAPHY_KEY_BODY1, TYPOGRAPHY_KEY_BODY2, TYPOGRAPHY_KEY_CAPTION, TYPOGRAPHY_KEY_OVERLINE, TYPOGRAPHY_KEY_BUTTON];

    export const MEMPHIS_THEME_METADATA: IThemeMetadata = {
        theme: MEMPHIS_THEME,
        palettes: MEMPHIS_THEME_PALETTES,
        paletteVariants: MEMPHIS_THEME_PALETTE_VARIANTS,
        schemes: MEMPHIS_THEME_SCHEMES,
        schemeVariants: MEMPHIS_THEME_SCHEME_VARIANTS,
        elevation: MEMPHIS_THEME_ELEVATION,
        elevationVariants: MEMPHIS_THEME_ELEVATION_VARIANTS,
        typographies: MEMPHIS_THEME_TYPOGRAPHY
    };

}
